import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=6ae6032a&scoped=true&"
import script from "@/views/Contact/Contact.ts?vue&type=script&lang=ts&"
export * from "@/views/Contact/Contact.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Contact/Contact.scss?vue&type=style&index=0&id=6ae6032a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae6032a",
  null
  
)

export default component.exports